

















































































































































































































































import { Meta } from "@/store/meta";
import { Vue, Component } from "vue-property-decorator";
import { Server } from "@/store/server";
import { getModule } from "vuex-module-decorators";

import CreateBoccoChannelForm, { CreateBoccoChannelFormValue } from '@/form/CreateBoccoChannelForm.vue'
import ConfirmCreateBoccoChannelModal from '../modal/ConfirmCreateBoccoChannelModal.vue';
import CreateServiceForm, { CreateServiceFormValue } from '../form/CreateServiceForm.vue';
import ConfirmCreateServiceModal from '../modal/ConfirmCreateServiceModal.vue';
import EditBoccoChannelModal from '../modal/EditBoccoChannelModal.vue'
import CreateServiceModal from '../modal/CreateServiceModal.vue'
import Tips from '@/components/Tips.vue'

@Component({
  components: {
    "create-bocco-channel-form": CreateBoccoChannelForm,
    "create-service-form": CreateServiceForm,
    "confirm-create-bocco-channel-modal": ConfirmCreateBoccoChannelModal,
    "confirm-create-service-modal": ConfirmCreateServiceModal,
    "edit-bocco-channel-modal": EditBoccoChannelModal,
    "create-service-modal": CreateServiceModal,
    "tips": Tips
  },
})
export default class ConfigChannel extends Vue {
  isLoading = true;

  isConfirmCreateChannelModalActive = false
  isConfirmCreateServiceModalActive = false
  isConfirmEditChannelModalActive = false
  isEditBoccoChannelModalActive = false
  isCreateServiceModalActive = false

  createChannelForm: CreateBoccoChannelFormValue | null = null
  createServiceForm: CreateServiceFormValue | null = null
  editChannelForm: CreateBoccoChannelFormValue | null  = null

  async mounted() {
    await this.initialLoad();
    this.isLoading = false;

    this.createChannelForm = {
      name: "", description: "", file: undefined
    }
    this.createServiceForm = {
      code: "", description: "", name: "", url: "", userName: "", file: undefined, useVoiceCommand: false, word: undefined, isBroadcast: this.meta.plan == "broadcaster"
    }
  }
  get meta() {
    return getModule(Meta);
  }
  get server() {
    return getModule(Server);
  }

  get isViewer() {
    return this.meta.isViewer
  }

  get boccoChannel() {
    return this.server.boccoChannel
  }

  get channelName() {
    if (this.boccoChannel == null || this.boccoChannel.channel == null) return ""
    return this.boccoChannel.channel.name
  }

  get channelDescription() {
    if (this.boccoChannel == null || this.boccoChannel.channel == null) return ""
    return this.boccoChannel.channel.description
  }

  get channelIcon() {
    if (this.boccoChannel == null || this.boccoChannel.channel == null) return null
    return this.boccoChannel.channel.icon
  }

  get channelServices() {
    if (this.boccoChannel == null || this.boccoChannel.channel == null) return []
    return this.boccoChannel.services
  }


  get activeStep() {
    if (this.boccoChannel == null) {
      return 0
    }

    if (this.boccoChannel.channel == null) {
      return 0
    }
   
    return 1
  }

  get setupRequired() {
    if (!this.boccoChannel) {
      return true
    }

    if (!this.boccoChannel.channel) {
      return true
    }
    if (this.boccoChannel.services.length == 0) {
      return true
    }

    return false
  }

  get needsIconRegistered() {
    if (this.setupRequired) {
      return false
    }

    return this.channelServices.filter(x => x.icon.length != 0).length == 0
  }

  get validChannelForm() {
    return CreateBoccoChannelForm.valid(this.createChannelForm!)
  }

  get validServiceForm() {
    return CreateServiceForm.valid(this.createServiceForm!)
  }

  get channelLoaded() {
    return !(this.boccoChannel == null)
  }

  get serviceLoaded() {
    if (!this.boccoChannel) {
      return false
    }

    return !(this.boccoChannel.services.length == 0)
  }

  onChannelEdit() {
    this.editChannelForm = {...this.boccoChannel!.channel!, file: undefined }
    this.isEditBoccoChannelModalActive = true
  }

  onServiceCreate() {
    this.isCreateServiceModalActive = true
  }

  async initialLoad() {
    await this.server.getBoccoChannel();
  }

  /**
   * BOCCOチャンネルの作成を実施。
   */
  async createBoccoChannel() {
    try {
      await this.server.postBoccoChannel({
        name: this.createChannelForm!.name,
        description: this.createChannelForm!.description,
        icon: this.createChannelForm!.file
      })
      this.$buefy.toast.open({
        message: "チャンネルを作成しました。",
        type: "is-success",
        duration: 5000,
      });
    } catch (error) {
        this.$buefy.toast.open({
          message:
            "送信に失敗しました。大変お手数ですが、しばらくお待ちいただいた後に、再度送信をお願いします。",
          type: "is-danger",
          duration: 5000,
        });
    } finally {
      this.isConfirmCreateChannelModalActive = false
    }
  }

  /**
   * BOCCOチャンネルサービスの作成を実施。
   */
  async createService() {
    try {
      const res = await this.server.postBoccoChannelService({
        "service_code": this.createServiceForm!.code,
        "service_name": this.createServiceForm!.name,
        "service_description": this.createServiceForm!.description,
        "channel_page_url": this.createServiceForm!.url,
        "broad_caster_name": this.createServiceForm!.userName,
        icon: this.createServiceForm!.file,
        "use_voice_command": this.createServiceForm!.useVoiceCommand,
        word: this.createServiceForm?.word
      })
      if (res.data.code == "duplication_code") {
        this.$buefy.toast.open({
          message: "このサービスコードは既に使われています。",
          type: "is-danger",
          duration: 5000,
        });

        return
      }

      if (res.status != 200) {
        throw Error("failed to request")
      }

      this.$buefy.toast.open({
        message: "サービスを作成しました。",
        type: "is-success",
        duration: 5000,
      });
    } catch (error){
        const errorMessage = "送信に失敗しました。大変お手数ですが、しばらくお待ちいただいた後に、再度送信をお願いします。";
        this.$buefy.toast.open({
          message: errorMessage,
          type: "is-danger",
          duration: 5000,
        });
    } finally {
      this.isConfirmCreateServiceModalActive = false
      await this.server.getBoccoChannel()
    }
  }

  createServiceConfirm() {
    this.isCreateServiceModalActive = false
    this.isConfirmCreateServiceModalActive = true
  }

  editBoccoChannelConfirm() {
    this.isEditBoccoChannelModalActive = false
    this.isConfirmEditChannelModalActive = true
  }

  /**
   * BOCCOチャンネルの編集依頼を実施。
   */
  async editBoccoChannel() {
    try {
      await this.server.putBoccoChannel({
        name: this.editChannelForm!.name,
        description: this.editChannelForm!.description,
        icon: this.editChannelForm!.file
      })
      this.$router.push({
        path: "/bocco-channel/done",
        query: { editType: "channel" },
      });
    } catch (error) {
        this.$buefy.toast.open({
          message:
            "送信に失敗しました。大変お手数ですが、しばらくお待ちいただいた後に、再度送信をお願いします。",
          type: "is-danger",
          duration: 5000,
        });
    } finally {
      this.isEditBoccoChannelModalActive = false
    }
  }
}
